import { createContext } from 'react'
import { FranchiseModel } from '../../../data/entity/franchise-model'

export const FranchiseContext = createContext<FranchiseModel>({} as unknown as FranchiseModel)